import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { PoliciesService } from 'src/app/shared/services/policyservices/policies.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import { SettingservicesService } from 'src/app/shared/services/settingservices/settingservices.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';


@Component({
  selector: 'app-add-policy',
  templateUrl: './add-policy.component.html',
  styleUrl: './add-policy.component.css',
  standalone: true,
  imports: [
    CommonModule, FormsModule, LoaderComponent, RouterModule, CKEditorModule
  ],
})
export class AddPolicyComponent implements OnInit {
  public Editor = ClassicEditor;

  public showSpinner = true;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  policyDetail: any;
  public policy_description = '';
  policy_id: any;
  data: any;
  uuid: any;
  policydata: any;
  policy_title: any;

  constructor(
    public _location: Location,
    private sharedmode: SharedModeService,
    private policyService: PoliciesService,
    public router: Router,
    public dashboardService: DashboardService,
    private settings: SettingservicesService,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => {
      this.uuid = params['uuid'];

      if (this.uuid !== undefined) {
        this.showPolicyData(this.uuid);
      }
    });
    this.user_detail();

  }

  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
    this.getpolicy()
  }

  showPolicyData(uuid: any) {
    this.showSpinner = true
    this.policyService.policyData(uuid).then((value) => {
      this.policy_description = value.policy_description
      this.policy_title = value.policy_title
      this.policy_id = value.id
    });
  }




  getpolicy() {
    this.showSpinner = true;
    this.policyService.getPolicy().then((value) => {
      this.policyDetail = value.data
    })
    this.showSpinner = false;
  }


  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
  onSubmit(f: NgForm) {
    const data = f.value
    this.showSpinner = true;
    if (this.policy_id) {
      this.settings.policyedit(data, this.policy_id).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Designation Edit Successfully',
            showConfirmButton: false,
            timer: 1500,
          });

        } else {

          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        this.router.navigate(['/policy']);
      })
    }
    else {
      data
      this.settings.policyCreate(data).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Policy Added Successfully',
            showConfirmButton: false,
            timer: 1500,
          });

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        this.router.navigate(['/policy']);
      })
    }




  }

}
